import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AgGridService {
  private triggerFunctionSource = new Subject<void>();
  private triggerFunctionExpand = new Subject<void>();

  triggerFunction$ = this.triggerFunctionSource.asObservable();
  triggerFunctionExpand$ = this.triggerFunctionExpand.asObservable();

  triggerFunction(choice: any) {
    this.triggerFunctionSource.next(choice);
  }

  triggerExpand(choice: any) {
    this.triggerFunctionExpand.next(choice);
  }
}
